import auth0 from 'auth0-js'
import { AUTH_CONFIG } from '@/auth0/auth0-variables'
import EventEmitter from 'eventemitter3'
//import router from '@/router'
import loggingService from '@/services/util/loggingService'

const isDebug = false
const lsKeySignedIn = 'shpo_signin_auth0'

const webAuth = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token',
    scope: 'openid profile email'
})

export default class AuthService {
    authenticated = this.isAuthenticated()
    authNotifier = new EventEmitter()
    idToken = null
    profile = null
    tokenExpiry = null

    constructor () {
        this.login = this.login.bind(this)
        this.setSession = this.setSession.bind(this)
        this.logout = this.logout.bind(this)
        this.isAuthenticated = this.isAuthenticated.bind(this)
        this.renewTokens = this.renewTokens.bind(this)
    }

    // auth0 = new auth0.WebAuth({
    //     domain: AUTH_CONFIG.domain,
    //     clientID: AUTH_CONFIG.clientId,
    //     redirectUri: AUTH_CONFIG.callbackUrl,
    //     audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    //     responseType: 'token id_token',
    //     scope: 'openid profile email'
    // })

    login () {
        webAuth.authorize()
    }

    handleAuthentication () {
        loggingService.log(isDebug, 'AuthService', 'handleAuthentication')
        webAuth.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult)
                var destination = localStorage.getItem('loginPlaceholder') || '/'
                loggingService.log(isDebug, 'AuthService', 'Going to ' + destination)
                window.location.href = destination
            } else if (err) {
                window.location.href = '/'
                loggingService.log(isDebug, 'AuthService', 'Error Parsing authResult')
                loggingService.log(isDebug, 'AuthService', err)
                alert(`Error: ${err.error}.\n
                    ${err.errorDescription}\n
                    Check the console for further details.`)
            }
        })
    }

    setSession (authResult) {
        this.idToken = authResult.idToken
        this.profile = authResult.idTokenPayload
        this.tokenExpiry = new Date(this.profile.exp * 1000)
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify(
            //authResult.expiresIn * 1000 + new Date().getTime()
            this.profile.exp * 1000
        )
        loggingService.log(isDebug, 'authService', 'token expires at: ' + this.tokenExpiry)
        localStorage.setItem('access_token', authResult.accessToken)
        localStorage.setItem('id_token', authResult.idToken)
        localStorage.setItem('expires_at', expiresAt)
        localStorage.setItem('profile', JSON.stringify(authResult.idTokenPayload))
        localStorage.setItem('authResult', JSON.stringify(authResult))
        localStorage.setItem(lsKeySignedIn, 'true')
        this.authNotifier.emit('authChange', { authenticated: true, authResult: authResult })
    }

    logout () {
        this.idToken = null
        this.tokenExpiry = null
        this.profile = null
        // Clear access token and ID token from local storage
        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('loginPlaceholder')
        localStorage.removeItem('profile')
        localStorage.removeItem('authResult')
        localStorage.removeItem(lsKeySignedIn)
        this.userProfile = null
        this.authNotifier.emit('authChange', { authenticated: false })
        // navigate to index
        webAuth.logout({
            returnTo: window.location.origin
        })
        window.location.href = '/'
    }

    isAuthenticated () {
        // Check whether the current time is past the expiry time
        let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
        let timeNow = new Date().getTime()
        loggingService.log(isDebug, 'authService - expiresAt', expiresAt)
        loggingService.log(isDebug, 'authService - time now', timeNow)
        return (timeNow < expiresAt) && (localStorage.getItem(lsKeySignedIn) === 'true')
    }

    renewTokens () {
        loggingService.log(isDebug, 'authSerivce', 'renewTokens')
        return new Promise((resolve, reject) => {
            if (localStorage.getItem(lsKeySignedIn) !== 'true') {
                loggingService.log(isDebug, 'authService', 'renewTokens - error - User not logged in')
                return reject('User not logged in')
            }
            webAuth.checkSession({}, (err, authResult) => {
                if (err) {
                    loggingService.log(isDebug, 'authService', 'renewTokens - error')
                    loggingService.logRaw(isDebug, err)
                    this.logout()
                    reject(err)
                } else {
                    loggingService.log(isDebug, 'authService', 'renewTokens - success')
                    loggingService.logRaw(isDebug, authResult)
                    this.setSession(authResult)
                    resolve(authResult)
                }
            })
        })
    }

}



// WEBPACK FOOTER //
// ./src/auth0/AuthService.js